import Vue from 'vue'

let base = '/apiv1/log/operatelog'
/**
 * 查询操作日志
 */
export const query = (params) => {
  return new Promise((resolve, reject) => {
    Vue.fetch.post(`${base}/query`, params).then(data => {
      resolve(data)
    }).catch(data => {
      reject(data)
    })
  })
}

/**
 * 删除操作日志
 */
export const remove = (params) => {
  return new Promise((resolve, reject) => {
    Vue.fetch.post(`${base}/delete`, params).then(data => {
      resolve(data)
    }).catch(data => {
      reject(data)
    })
  })
}



// WEBPACK FOOTER //
// ./src/cdpBase/services/operateLog.js